import React from 'react';
import * as PropTypes from 'prop-types';
import { AmsaleLogo, HamburgerIcon, SearchIcon, ShoppingBagIcon, UserIcon } from './svg/AmsaleIcons';
import { mainMenuData } from './menuData/MenuTree';
import DesktopMainNav from './DesktopMainNav';

function AmsaleHeader({ setMobileMenuOpen }) {
  const handleBurgerClick = () => {
    setMobileMenuOpen(true);
    document.documentElement.classList.add('sidebar--open');
    document.querySelector('.drawer-overlay').classList.add('show');
  };

  const handleOnFocus = () => {
    const topLevelLinks = document.querySelectorAll('.top-level-link');
    for (const link of topLevelLinks) {
      link.classList.remove('active');
    }
  };

  return (
    <header className="site--header fixed-header">
      <div className="page-container page-width">
        <div className="menu-flex-container">
          <a href="#" id="mobile-toggle" className="mobile-toggle" onClick={handleBurgerClick}>
            <HamburgerIcon />
          </a>
          <div className="nav-left">
            <div className="site-logo">
              <a href={`${process.env.SHOPIFY_URL}`} itemProp="url">
                <AmsaleLogo />
              </a>
            </div>
            <DesktopMainNav mainMenu={mainMenuData.left} klassName="left-menu" />
          </div>
          <div className="nav-right">
            <DesktopMainNav mainMenu={mainMenuData.right} klassName="right-menu" />
            <ul className="menu-actions">
              <li>
                <a href={`https://${process.env.SHOPIFY_DOMAIN}/search`} className="search-btn" onFocus={(e) => handleOnFocus(e)}>
                  <SearchIcon />
                </a>
              </li>
              <li className="user-account-link">
                <a href={`${process.env.PROXY_PATH}/profile`}>
                  <UserIcon />
                </a>
              </li>
              <li>
                <a href={`https://${process.env.SHOPIFY_DOMAIN}/cart`} className="search-btn">
                  <ShoppingBagIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}

AmsaleHeader.propTypes = {
  setMobileMenuOpen: PropTypes.func.isRequired,
};

export default AmsaleHeader;
